import { Fragment, useId } from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import AccommodationPackageInclusionItem from './AccommodationPackageInclusionItem'
import AccommodationPackageInclusionsToggle from './AccommodationPackageInclusionsToggle'
import { getVisiblePackageInclusionsCount, type PackageInclusionEntry } from './packageInclusions'

interface ListProps {
  entries: Array<PackageInclusionEntry>
  limit: 4 | 8
  showAll: boolean
  expanded: boolean
  onToggle: () => void
}

function AccommodationPackageInclusionsList({ entries, limit, showAll, expanded, onToggle }: ListProps) {
  const listId = useId()
  const initiallyVisible = getVisiblePackageInclusionsCount(entries.length, { limit, showAll })
  const visible = expanded ? entries : entries.slice(0, initiallyVisible)

  return <VerticalSpacer gap={8}>
    <VerticalSpacer gap={4} id={listId}>
      {visible.map(({ category, row, heading }) => <Fragment key={`${category}:${'inclusion' in row ? row.inclusion.id : row.id}`}>
        {heading}
        {'inclusion' in row && <AccommodationPackageInclusionItem inclusion={row.inclusion} category={category} endIcon={row.endIcon} />}
        {!('inclusion' in row) && row.content}
      </Fragment>)}
    </VerticalSpacer>
    <AccommodationPackageInclusionsToggle
      expanded={expanded}
      remainingCount={entries.length - initiallyVisible}
      listId={listId}
      onToggle={onToggle}
    />
  </VerticalSpacer>
}

export default AccommodationPackageInclusionsList
